export function removeParentPrefix(
  name: string,
  parentFieldName?: string
): string {
  if (!parentFieldName) {
    return name;
  }
  return name ? name.replace(parentFieldName + '-', '') : '';
}
